// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WiderrufRouteImport } from './routes/widerruf'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as HowToPlayRouteImport } from './routes/how-to-play'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppGameRouteImport } from './routes/_app.game'
import { Route as AppGameIndexRouteImport } from './routes/_app.game.index'
import { Route as AppGameStableRouteImport } from './routes/_app.game.stable'
import { Route as AppGameShopRouteImport } from './routes/_app.game.shop'
import { Route as AppGameSchmiedeRouteImport } from './routes/_app.game.schmiede'
import { Route as AppGameOperatorRouteImport } from './routes/_app.game.operator'
import { Route as AppGameOnboardingRouteImport } from './routes/_app.game.onboarding'
import { Route as AppGameMovesRouteImport } from './routes/_app.game.moves'
import { Route as AppGameInventoryRouteImport } from './routes/_app.game.inventory'
import { Route as AppGameHomeRouteImport } from './routes/_app.game.home'
import { Route as AppGameGoldShopRouteImport } from './routes/_app.game.gold-shop'
import { Route as AppGameExpeditionsRouteImport } from './routes/_app.game.expeditions'
import { Route as AppGameBreedingRouteImport } from './routes/_app.game.breeding'
import { Route as AppGameBattleRouteImport } from './routes/_app.game.battle'
import { Route as AppGameAchievementsRouteImport } from './routes/_app.game.achievements'
import { Route as AppGameMarketplaceIndexRouteImport } from './routes/_app.game.marketplace.index'
import { Route as AppGameMarketplaceListingIdRouteImport } from './routes/_app.game.marketplace.$listingId'

const WiderrufRoute = WiderrufRouteImport.update({
            id: '/widerruf',path: '/widerruf',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const HowToPlayRoute = HowToPlayRouteImport.update({
            id: '/how-to-play',path: '/how-to-play',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppGameRoute = AppGameRouteImport.update({
            id: '/game',path: '/game',getParentRoute: () => AppRoute
          })
const AppGameIndexRoute = AppGameIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppGameRoute
          })
const AppGameStableRoute = AppGameStableRouteImport.update({
            id: '/stable',path: '/stable',getParentRoute: () => AppGameRoute
          })
const AppGameShopRoute = AppGameShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => AppGameRoute
          })
const AppGameSchmiedeRoute = AppGameSchmiedeRouteImport.update({
            id: '/schmiede',path: '/schmiede',getParentRoute: () => AppGameRoute
          })
const AppGameOperatorRoute = AppGameOperatorRouteImport.update({
            id: '/operator',path: '/operator',getParentRoute: () => AppGameRoute
          })
const AppGameOnboardingRoute = AppGameOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AppGameRoute
          })
const AppGameMovesRoute = AppGameMovesRouteImport.update({
            id: '/moves',path: '/moves',getParentRoute: () => AppGameRoute
          })
const AppGameInventoryRoute = AppGameInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AppGameRoute
          })
const AppGameHomeRoute = AppGameHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AppGameRoute
          })
const AppGameGoldShopRoute = AppGameGoldShopRouteImport.update({
            id: '/gold-shop',path: '/gold-shop',getParentRoute: () => AppGameRoute
          })
const AppGameExpeditionsRoute = AppGameExpeditionsRouteImport.update({
            id: '/expeditions',path: '/expeditions',getParentRoute: () => AppGameRoute
          })
const AppGameBreedingRoute = AppGameBreedingRouteImport.update({
            id: '/breeding',path: '/breeding',getParentRoute: () => AppGameRoute
          })
const AppGameBattleRoute = AppGameBattleRouteImport.update({
            id: '/battle',path: '/battle',getParentRoute: () => AppGameRoute
          })
const AppGameAchievementsRoute = AppGameAchievementsRouteImport.update({
            id: '/achievements',path: '/achievements',getParentRoute: () => AppGameRoute
          })
const AppGameMarketplaceIndexRoute = AppGameMarketplaceIndexRouteImport.update({
            id: '/marketplace/',path: '/marketplace/',getParentRoute: () => AppGameRoute
          })
const AppGameMarketplaceListingIdRoute = AppGameMarketplaceListingIdRouteImport.update({
            id: '/marketplace/$listingId',path: '/marketplace/$listingId',getParentRoute: () => AppGameRoute
          })





const AppGameRouteChildren = {
  AppGameAchievementsRoute: AppGameAchievementsRoute,AppGameBattleRoute: AppGameBattleRoute,AppGameBreedingRoute: AppGameBreedingRoute,AppGameExpeditionsRoute: AppGameExpeditionsRoute,AppGameGoldShopRoute: AppGameGoldShopRoute,AppGameHomeRoute: AppGameHomeRoute,AppGameInventoryRoute: AppGameInventoryRoute,AppGameMovesRoute: AppGameMovesRoute,AppGameOnboardingRoute: AppGameOnboardingRoute,AppGameOperatorRoute: AppGameOperatorRoute,AppGameSchmiedeRoute: AppGameSchmiedeRoute,AppGameShopRoute: AppGameShopRoute,AppGameStableRoute: AppGameStableRoute,AppGameIndexRoute: AppGameIndexRoute,AppGameMarketplaceListingIdRoute: AppGameMarketplaceListingIdRoute,AppGameMarketplaceIndexRoute: AppGameMarketplaceIndexRoute
}

const AppGameRouteWithChildren = AppGameRoute._addFileChildren(AppGameRouteChildren)



const AppRouteChildren = {
  AppGameRoute: AppGameRouteWithChildren
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AgbRoute: AgbRoute,AuthRoute: AuthRoute,DatenschutzRoute: DatenschutzRoute,FaqRoute: FaqRoute,HowToPlayRoute: HowToPlayRoute,ImpressumRoute: ImpressumRoute,PricingRoute: PricingRoute,ResetPasswordRoute: ResetPasswordRoute,WiderrufRoute: WiderrufRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)